import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import Button from '~/components/Button'
import TextInput from '~/components/TextInput'
import { useUser } from '@verzekeringapp-mono/shared/src/hooks/use_user'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getUser } from '@verzekeringapp-mono/shared/src/state/selectors/user'

const AccountForm: React.FC = () => {
  const user = useAppSelector(getUser)
  const {
    handleSubmit,
    control,
    formState: { isValid }
  } = useForm({
    defaultValues: {
      firstName: user?.firstName ?? ''
    }
  })
  const { updateUser } = useUser()
  const [feedback, setFeedback] = React.useState<string | null>(null)

  return (
    <form
      onSubmit={handleSubmit(async data => {
        updateUser(
          {
            firstName: data.firstName
          }).then(() => {
          setFeedback('Je voornaam is succesvol gewijzigd.')
        }).catch((err) => {
          alert(err.message || 'Er is een fout opgetreden bij het wijzigen van je voornaam. Probeer het later opnieuw.')
        })
      })}
      className='md:w-1/2 w-full'
    >
      <Controller
        name='firstName'
        control={control}
        render={({ field, fieldState }) => (
          <TextInput
            label='Voornaam'
            type='text'
            placeholder='Voornaam'
            icon='user'
            isValid={!fieldState.invalid}
            {...field}
          />
        )}
      />

      <Button
        className={`primary-btn w-full ${
          isValid ? '' : 'opacity-50'
        } mt-8 mb-3`}
        type='submit'
        disabled={!isValid}
      >
        Opslaan
      </Button>

      {feedback && <p className='mt-2 text-status-success-foreground'>{feedback}</p>}
    </form>
  )
}

export default AccountForm
